<template>
  <VueFinalModal
    :esc-to-close="true"
    class="flex justify-center items-center "
    content-class="relative flex flex-col w-2/4 h-auto mx-auto bg-white border rounded-lg"
  >
    <div class="p-4" id="content">
      <div class="pb-4 text-xl">Training Center Status</div>
      <div class="info" v-for="(value, name, id) in data" :key="id">
        <div class="bold">{{ name.replace('_', ' ') }}:</div>
        <div class="value">{{ value }}</div>
      </div>

      <button class="btn btn-secondary float-right" @click="closeModal()">Close</button>
    </div>
  </VueFinalModal>
</template>

<script setup>
  import { onMounted, ref } from 'vue'
  import { VueFinalModal } from 'vue-final-modal'

  const props = defineProps({
    params: Object,
  })

  const emit = defineEmits(['close'])

  let data = ref({})

  onMounted(() => {
// changed this so only values appropriate for current status are displayed
    data.value = {
        Name: props.params.data.training_center.name,
        Started: props.params.data.training_center.start_date.split('T')[0],
        State: props.params.data.training_center.state
    }
    if (props.params.data.training_center.state == 'under_review') {
      Object.assign(data.value, {
        Review_Reason: props.params.data.training_center.under_review_reason_text,
        Review_Date: props.params.data.training_center.under_review_date,
      })
    } else if (props.params.data.training_center.state == 'dropped') {
      Object.assign(data.value, {
        Code: props.params.data.training_center.dropped_reason_code,
        Reason: props.params.data.training_center.dropped_reason_text,
        Date: props.params.data.training_center.dropped_date,
      })
    } else if (props.params.data.training_center.state == 'graduated') {
      Object.assign(data.value, {Date_Graduated: props.params.data.training_center.graduation_date })
    } else if (props.params.data.training_center.under_review_reason_text) {
      Object.assign(data.value, {
        Reason: props.params.data.training_center.under_review_reason_text,
        Date: props.params.data.training_center.under_review_date,
      })
    } else if (props.params.data.training_center.state == 'suspended') {
      Object.assign(data.value, {
        Reason: props.params.data.training_center.suspended_reason_text,
        Date: props.params.data.training_center.suspended_at.substring(0, 10),
      })
    }
    console.log(data.value)
  })

  function closeModal () {
    emit("close")
  }
</script>

<style>
  .vm--modal {
    overflow: initial !important;
  }
  .info {
    padding: 10px;
    display: flex;
    flex-direction: row;
  }
  .bold {
    font-weight: bold;
  }
  .value {
    padding-left: 5px;
  }
  #content:after {
    visibility: hidden;
    display: block;
    font-size: 0;
    content: " ";
    clear: both;
    height: 0;
}
</style>
